import { useEffect } from "react";
import BrowserComponent from "./BroswerComponent";
import { useSelector } from "react-redux";
import { RootUrl } from "../../redux/types";

const PrintComponent = (props) => {
  const isElectron = window?.api?.isElectron;

  const {
    printData,
    enablePrinting,
    enableLogo,
    enableBranchName,
    enableAddress,
    enableGSTNumber,
    enableFssaiNumber,
    enableCustomer,
    exclusiveGST,
    printType,
    billPrinter,
  } = useSelector((state) => state.util);

  const role = useSelector((state) => state.user.role);
  const isRestaurantAdmin = role === "restaurantadmin";

  const printSetting = {
    enableLogo,
    enableBranchName,
    enableAddress,
    enableGSTNumber,
    enableCustomer,
    exclusiveGST,
    billPrinter,
  };
  const logo = RootUrl + "/" + useSelector((state) => state.user.logo);

  const {
    branchName,
    gstNumber,
    branchAddress,
    fssaiNumber,
    receiptMessage: currReceiptMessage,
  } = useSelector((state) => state.user);

  const allTables = useSelector((state) => state.branch.tables);
  let tableType = allTables.filter((table) => {
    return table?.tableNumber === printData?.tableNumber;
  });

  if (printData?.orderType === "Home Delivery") {
    tableType = [{ tableType: "Online" }];
  }
  const restaurant = `${branchName && enableBranchName ? `${branchName}` : ""}`;

  const receiptMessage =
    currReceiptMessage && currReceiptMessage !== null
      ? currReceiptMessage
      : undefined;
  useEffect(() => {
    if (isElectron && printData) {
      window.api.printBillSilently({
        logo: enableLogo && logo,
        printData,
        restaurant,
        gstNumber,
        fssaiNumber,
        receiptMessage: receiptMessage,
        branchAddress,
        printSetting,
      });
    }
  }, [printData, enablePrinting]);

  return isRestaurantAdmin ? (
    <BrowserComponent
      printData={printData}
      logo={enableLogo && logo}
      restaurant={restaurant}
      gstNumber={(enableGSTNumber || isRestaurantAdmin) && gstNumber}
      fssaiNumber={enableFssaiNumber && fssaiNumber}
      branchAddress={enableAddress && branchAddress}
      receiptMessage={receiptMessage}
      printSetting={printSetting}
      printType={printType}
      isRestaurantAdmin={isRestaurantAdmin}
      tableType={tableType[0]}
    />
  ) : !enablePrinting ? (
    <div />
  ) : isElectron ? (
    <div />
  ) : (
    <BrowserComponent
      printData={printData}
      logo={enableLogo && logo}
      restaurant={restaurant}
      gstNumber={enableGSTNumber && gstNumber}
      fssaiNumber={enableFssaiNumber && fssaiNumber}
      branchAddress={enableAddress && branchAddress}
      receiptMessage={receiptMessage}
      printSetting={printSetting}
      printType={printType}
      isRestaurantAdmin={isRestaurantAdmin}
      tableType={tableType[0]}
    />
  );
};

export default PrintComponent;
